/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Widget_EmptyInputs */

const en_dashboard_widget_empty = /** @type {(inputs: Dashboard_Widget_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No cases match the selected filters.`)
};

const pt_br2_dashboard_widget_empty = /** @type {(inputs: Dashboard_Widget_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum caso corresponde aos filtros selecionados.`)
};

/**
* | output |
* | --- |
* | "No cases match the selected filters." |
*
* @param {Dashboard_Widget_EmptyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_widget_empty = /** @type {((inputs?: Dashboard_Widget_EmptyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Widget_EmptyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_widget_empty(inputs)
	return pt_br2_dashboard_widget_empty(inputs)
});